export default __webpack_public_path__ + "static/media/mail.eb7cc9a0.svg";